import { I18nextProvider } from "react-i18next";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./App.scss";
import Layout from "./components/layout/Layout";
import ScrollToTop from "./components/ScrollToTop";
import { AuthProvider } from "./context/AuthContext";
import LoginModal from "./context/LoginModal";
import "./i18n";
import i18n from "./i18n";
import AppRoutes from "./routes/AppRoutes";
import { store } from "./store/store";
import "./styles/HomePage.scss";
import LanguageWrapper from "./components/layout/LanguageWrapper";
import { setFaviconByDomain } from "./setFaviconByDomain";

function App() {
  const queryClient = new QueryClient();

  return (
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <Router>
          <QueryClientProvider client={queryClient}>
            <ScrollToTop />
            <AuthProvider>
              <LanguageWrapper>
                <Layout>
                  <LoginModal />
                  <AppRoutes />
                </Layout>
              </LanguageWrapper>
            </AuthProvider>
          </QueryClientProvider>
        </Router>
      </I18nextProvider>
    </Provider>
  );
}

export default App;

setFaviconByDomain();
